{
    "(save {highestYearlyDiscount}%)": "(caomhain {highestYearlyDiscount}%)",
    "{amount} days free": "{amount}l an-asgaidh",
    "{amount} off": "{amount} dheth",
    "{amount} off for first {number} months.": "{amount} dheth fad {number}m",
    "{amount} off for first {period}.": "{amount} dheth fad a’ chiad {period}",
    "{amount} off forever.": "{amount} dheth gu bràth",
    "{discount}% discount": "lasachadh {discount}%",
    "{memberEmail} will no longer receive {newsletterName} newsletter.": "Chan fhaigh {memberEmail} a’ chuairt-litir, {newsletterName} tuilleadh.",
    "{memberEmail} will no longer receive emails when someone replies to your comments.": "Chan fhaigh {memberEmail} post-d nuair a bhios freagairtean ùra ann.",
    "{memberEmail} will no longer receive this newsletter.": "Chan fhaigh {memberEmail} a’ chuairt-litir seo tuilleadh.",
    "{memberEmail} will no longer receive updates & announcements.": "",
    "{months} months": "",
    "{months} months free": "",
    "{tierName} membership": "",
    "{trialDays} days free": "{trialDays}l an-asgaidh",
    "{years} years": "",
    "+1 (123) 456-7890": "+44 1234 567890",
    "1 month": "",
    "1 month free": "",
    "1 year": "",
    "A gift, just for you": "",
    "Access your RSS feeds": "",
    "Account": "Cunntas",
    "Account details updated successfully": "Chaidh roghainnean a' chunntais ùrachadh gu soirbheachail",
    "Account settings": "Roghainnean",
    "Add a personal note": "",
    "After a free trial ends, you will be charged the regular price for the tier you've chosen. You can always cancel before then.": "Bidh agad ri pàigheadh nuair a dh’fhalbhachas an ùine air an tionndadh triail agad. Faodaidh tu ga sguir dheth ron a shin ge-tà.",
    "Already a member?": "’Eil thu nad bhall mar-thà?",
    "An error occurred": "Thachair mearachd",
    "An unexpected error occured. Please try again or <a>contact support</a> if the error persists.": "Thachair mearachd. Feuch a-rithist, no <a>leig fios dhan sgioba-taice</a>.",
    "Back": "Air ais",
    "Back to Log in": "Thill gus clàradh a-steach",
    "Before you go": "",
    "Billing info & receipts": "",
    "Black Friday": "Black Friday",
    "Bluesky": "",
    "Cancel anytime.": "Sguir dheth uair sam bith",
    "Cancel subscription": "Sguir dhen fo-sgrìobhadh",
    "Canceled": "",
    "Cancellation reason": "Adbhar airson sguir dheth",
    "Change": "Atharraich",
    "Change plan": "Atharraich a' phlana",
    "Check spam & promotions folders": "Thoir sùil air a’ phasgan spama / margaidheachd agad",
    "Check with your mail provider": "Faighnich air solaraiche a’ phuist-d agad",
    "Check your inbox to verify email update": "Thoir sùil air a' phost-d agad gus an ùrachadh a dhearbhadh",
    "Choose": "Tagh",
    "Choose a different plan": "Tagh plana eile",
    "Choose a plan": "Tagh plana",
    "Choose your newsletters": "Tagh na cuairt-litrichean agad",
    "Click here to retry": "Briog an seo gus feuchainn a-rithist",
    "Click the confirmation link in your inbox to finish redeeming your membership. If it doesn't arrive within 3 minutes, check your spam folder.": "",
    "Close": "Dùin",
    "Code": "",
    "Comment preferences updated.": "Chaidh roghainnean nam beachd ùrachadh",
    "Comments": "Beachdan",
    "Complimentary": "An-asgaidh",
    "Confirm": "Dearbhaich",
    "Confirm cancellation": "Deabhaich gu bheil thu airson sguir dheth",
    "Confirm subscription": "Dearbhaich am fo-sgrìobhadh",
    "Contact support": "Leig fios dhan sgioba-taice",
    "Continue": "Lèan ort",
    "Continue subscription": "Cùm am fo-sgrìobhadh a’ dol",
    "Continue with a paid subscription anytime. Your remaining gift period will be added as a free trial.": "",
    "Copied": "",
    "Copy": "",
    "Copy link": "",
    "Could not create Stripe billing portal session": "",
    "Could not create Stripe checkout session": "Cha ghabh seisean Stripe a thòiseachadh",
    "Could not sign in. Login link expired.": "Chan urrainn dhut clàradh a-steach. Dh’fhalbh an ùine air a’ cheangal a lean thu.",
    "Could not update email! Invalid link.": "Cha do ghabh am post-d ùrachadh! Ceangal mì-dhligheach",
    "Create a new contact": "Cruthaich neach-aithne ùr",
    "Current plan": "Am plana làithreach",
    "Delete account": "Sguab às an cunntas",
    "Didn't mean to do this? Manage your preferences <button>here</button>.": "An robh thu airson seo a dhèanamh? Rianaich <button>na roghainnean agad</button>.",
    "Don't have an account?": "Nach eil cunntas agad?",
    "Edit": "Deasaich",
    "Email": "Post-d",
    "Email confirmation link expired.": "",
    "Email newsletter": "Cuairt-litir",
    "Email newsletter settings updated": "Chaidh roghainnean na cuairt-litreach ùrachadh",
    "Email preferences": "Roghainnean puist-d",
    "Email preferences updated.": "Chaidh na roghainnean puist-d ùrachadh.",
    "Emails": "Puist-d",
    "Emails disabled": "Puist-d à comas",
    "Ends {offerEndDate}": "Falbhaidh an ùine air: {offerEndDate}",
    "Enjoy {amountOff} off forever.": "",
    "Enjoy {months} free months on us.": "",
    "Enjoy {months} free months on us. You won't be charged until {newBillingDate}.": "",
    "Enjoy a free month on us.": "",
    "Enjoy a free month on us. You won't be charged until {newBillingDate}.": "",
    "Enter code above": "",
    "Enter your email address": "Cuir a-steach seòladh a' phuist-d agad",
    "Enter your name": "Cuir a-steach d' ainm",
    "Error": "Mearachd",
    "Expires {expiryDate}": "Falbhaidh an ùine air: {expiryDate}",
    "Facebook": "",
    "Failed to cancel subscription, please try again": "Dh’fhàillig dùbhadh às an fho-sgrìobhaidh, feuch a-rithist",
    "Failed to log in, please try again": "Dh’fhàillig clàradh a-steach, feuch a-rithist",
    "Failed to log out, please try again": "Dh’fhàillig clàradh a-mach, feuch a-rithist",
    "Failed to open billing portal, please try again": "",
    "Failed to process checkout, please try again": "Dh'fhàillig a' cheannachd",
    "Failed to send magic link email": "Dh’fhàillig cur a' phuist-d",
    "Failed to send verification email": "Dh’fhàillig cur a' phuist-d",
    "Failed to sign up, please try again": "Dh’fhàillig clàradh",
    "Failed to update account data": "Dh’fhàillig ùrachadh a' chunntais",
    "Failed to update account details": "Dh’fhàillig ùrachadh a' chunntais",
    "Failed to update billing information, please try again": "",
    "Failed to update newsletter settings": "Dh’fhàillig ùrachadh roghainnean na cuairt-litreach",
    "Failed to update subscription, please try again": "Dh’fhàillig ùrachadh an fho-sgrìobhaidh, feuch a-rithist",
    "Failed to verify code, please try again": "",
    "Forever": "Gu bràth",
    "Free Trial – Ends {trialEnd}": "Falbhaidh an ùine air an tionndadh triail an-asgadh: {trialEnd}",
    "Get help": "Iarr cobhair",
    "Get in touch for help": "Iarr cobhair",
    "Get notified when someone replies to your comment": "Faigh brath nuair a bhios freagairtean ùra ris a’ bheachd agad",
    "Gift a membership": "",
    "Gift could not be redeemed": "",
    "Gift details": "",
    "Gift redeemed! You're all set.": "",
    "Gift subscription": "",
    "Gift subscriptions are not available right now.": "",
    "Gift value": "",
    "Give feedback on this post": "Fàg beachd air a’ phost seo",
    "Help! I'm not receiving emails": "Cuidich mi! Chan eil mi a’ faighinn puist-d",
    "Here are a few other sites you may enjoy.": "Seo agad grunn làraichean-lìn eile a dh’fhaodadh a bhith còrdadh riut.",
    "Hide details": "",
    "If a newsletter is flagged as spam, emails are automatically disabled for that address to make sure you no longer receive any unwanted messages.": "Ma chomharras tu post-d mar spama, thèid bacadh a chur air an seòladh gu fèin-ghluasadach gus dèanamh cinnteach nach faigh thu puist-d a bharrachd nach eil thu ag iarraidh.",
    "If the spam complaint was accidental, or you would like to begin receiving emails again, you can resubscribe to emails by clicking the button on the previous screen.": "Ma tha thu airson puist-d fhaighinn a-rithist, faodaidh tu fo-sgrìobhadh a-rithist le bhith a’ briogadh air a’ cheangail air an duilleag roimhe.",
    "If you cancel your subscription now, you will continue to have access until {periodEnd}.": "Ma chuireas tu stad air a’ bhallrachd agad, bidh cothrom inntrididh agad air gu ruige: {periodEnd}.",
    "If you have a corporate or government email account, reach out to your IT department and ask them to allow emails to be received from {senderEmail}": "Ma tha post-d corparra agad, dh’fhaodadh gu bheil agad ri innse dhan sgioba IT agad puist-d bho {senderEmail} a cheadachadh.",
    "If you have an account, a login link has been sent to your inbox. If it doesn't arrive in 3 minutes, be sure to check your spam folder.": "Chaidh ceangal a chur dhan phost-d agad. Thoir sùil air a’ phasgan spama mura faigh thu taobh a-staigh 3 mionaidean e.",
    "If you have an account, an email has been sent to {submittedEmailOrInbox}. Click the link inside or enter your code below.": "",
    "If you would like to start receiving emails again, the best next steps are to check your email address on file for any issues and then click resubscribe on the previous screen.": "Ma tha thu airson puist-d fhaighinn a-rithist, faodaidh tu fo-sgrìobhadh a-rithist le bhith a’ briogadh air a’ cheangail air an duilleag roimhe.",
    "If you're not receiving the email newsletter you've subscribed to, here are a few things to check.": "Thoir sùil air na rudan na leanas mura h-eil thu a’ faighinn puist-d.",
    "If you've completed all these checks and you're still not receiving emails, you can reach out to get support by contacting {supportAddress}.": "Leig fios gu {supportAddress} mura h-eil thu a’ faighinn puist-d an dèidh sùil a thoirt air na rudan seo.",
    "In the event a permanent failure is received when attempting to send a newsletter, emails will be disabled on the account.": "Thèid puist-d a chur à comas ma thacras mearachd seasmhach.",
    "In your email client add {senderEmail} to your contacts list. This signals to your mail provider that emails sent from this address should be trusted.": "Cuir {senderEmail} ri liosta nan luchd-aithne agad agus cuidichidh seo le bhith ag innse don t-solaraiche puist-d agad gur e seòladh post-d earbsach a tha seo.",
    "Invalid email address": "Seòladh puist-d ceàrr",
    "Invalid verification code": "",
    "Jamie Larson": "Ainm Sloinneadh",
    "jamie@example.com": "ainm@eisimpleir.com",
    "Less like this": "Nas lugha mar seo",
    "LinkedIn": "",
    "Make sure emails aren't accidentally ending up in the Spam or Promotions folders of your inbox. If they are, click on \"Mark as not spam\" and/or \"Move to inbox\".": "Dh’fhaodadh gu bheil puist-d a’ dol dhan phasgan spama / margaidheachd agad. Ma tha, Comharraich \"nach e spama\" a th’ annta no briog air \"gluais dhan bhogsa a-steach\".",
    "Manage": "Rianaich",
    "Maybe later": "’S mathaid an ceann greis",
    "Membership details": "",
    "Memberships from this email domain are currently restricted.": "",
    "Memberships unavailable, contact the owner for access.": "Leig fios dhan rianaire airson cothrom fhaighinn air na ballrachdan.",
    "month": "mìos",
    "Monthly": "Gach mìos",
    "More like this": "Barrachd mar seo",
    "More options": "",
    "Name": "Ainm",
    "Need more help? Contact support": "’Eil thu feumach air barrachd chobhair? Leig fios dhan sgioba-taice",
    "Newsletters can be disabled on your account for two reasons: A previous email was marked as spam, or attempting to send an email resulted in a permanent failure (bounce).": "Dh’fhaodadh gu bheil cuairt-litrichean à comas air sgàth ’s gun deach post-d roimhe a chomharradh mar spama, no air sgàth ’s nach do ghabh e a lìbhreachadh.",
    "No member exists with this e-mail address.": "Chan eil cleachdaiche ann leis a' phost-d seo.",
    "No thanks, I want to cancel": "",
    "Not ready to share? We've also emailed a copy to your inbox.": "",
    "Not receiving emails?": "Nach eil thu a’ faighinn puist-d?",
    "Now check your email!": "Thoir sùil air a’ phost-d agad",
    "Occasional updates from {siteTitle}": "",
    "Once resubscribed, if you still don't see emails in your inbox, check your spam folder. Some inbox providers keep a record of previous spam complaints and will continue to flag emails. If this happens, mark the latest newsletter as 'Not spam' to move it back to your primary inbox.": "Thoir sùil air a’ phasgan spama agad mura faigh thu puist-d aon uair ’s gu bheil thu air fo-sgrìobhadh a-rithist. Cumaidh cuid de sholaraichean puist de chlàr de sheann ghearanan spama agus ma dh’fhaoidte gu bheil iad fhathast gan comharradh mar spama. Comharraich \"nach e spama\" a th’ annta gus an gluasad air ais dhan bhogsa a-steach agad.",
    "Open AOL Mail": "",
    "Open email": "",
    "Open Feedbin": "",
    "Open Gmail": "",
    "Open Hey": "",
    "Open iCloud Mail": "",
    "Open Mail.ru": "",
    "Open Outlook": "",
    "Open Proton Mail": "",
    "Open Yahoo Mail": "",
    "Permanent failure (bounce)": "Fàilleadh maireannach",
    "Phone number": "Àireamh-fòn",
    "Plan": "Plana",
    "Plan checkout was cancelled.": "Chaidh an t-ordugh a chur dheth.",
    "Plan upgrade was cancelled.": "Chaidh an t-àrdachadh a chur dheth.",
    "Please contact {supportAddress} to adjust your complimentary subscription.": "Leig fios gu {supportAddress} gus am fo-sgrìobhadh an-asgaidh a atharrachadh.",
    "Please enter {fieldName}": "Lìon a-steach an roinn seo: {fieldName}",
    "Please fill in required fields": "Lìon a-steach na raointean riatanach",
    "Podcasts": "",
    "Re-enable emails": "Cuir an comas puist-d a-rithist",
    "Recommendations": "Mòlaidhean",
    "Redeem your membership": "",
    "Redeeming...": "",
    "Renews at {price}.": "Prìs ath-nuadhachaidh: {price}",
    "Resume subscription": "",
    "Retry": "Feuch a-rithist",
    "Save": "Sàbhail",
    "Save {amountOff} on your next {durationInMonths} billing cycles. Then {currency}{originalPrice}/{cadence}.": "",
    "Save {amountOff} on your next billing cycle. Then {currency}{originalPrice}/{cadence}.": "",
    "Send an email and say hi!": "Cuir post-d is can halò!",
    "Send an email to {senderEmail} and say hello. This can also help signal to your mail provider that emails to and from this address should be trusted.": "Cuir post-d gu {senderEmail} is can halò. Cuidichidh seo le bhith ag innse don t-solaraiche puist-d agad gur e seòladh post-d earbsach a tha seo.",
    "Send the link below to share it with whoever you'd like.": "",
    "Sending login link...": "A’ cur ceangal clàraidh a-steach...",
    "Sending...": "’Ga chur...",
    "Share": "",
    "Share a full membership to {siteTitle} with a friend or colleague": "",
    "Show all": "Seall na h-uile",
    "Sign in": "Clàraich a-steach",
    "Sign out": "Clàraich a-mach",
    "Sign up": "Clàraich",
    "Signup error: Invalid link": "Mearachd: Ceangal mì-dhligheach",
    "Signups from this email domain are currently restricted.": "",
    "Something went wrong, please try again later.": "Thachair mearachd, feuch a-rithist an ceann greis.",
    "Sorry, no paid plans are available.": "",
    "Sorry, no recommendations are available right now.": "",
    "Sorry, that didn’t work.": "Duilich, cha do dh’obraich sin.",
    "Spam complaints": "Gearanan spama",
    "Start {amount}-day free trial": "Cleachd tionndadh triail fad {amount}l",
    "Starting {startDate}": "A’ tòiseachadh: {startDate}",
    "Starting today": "A’ tòiseachadh an-diugh",
    "Submit feedback": "Fàg beachd air",
    "Subscribe": "Fo-sgrìobh",
    "Subscribed": "Air fho-sgrìobhadh",
    "Subscription plan updated successfully": "Chaidh am fo-sgrìobhadh ùrachadh gu soirbheachail",
    "Success": "Dèanta",
    "Success! Check your email for magic link to sign-in.": "Dèanta! Thoir sùil air a’ phost-d agad airson a’ cheangal clàraidh a-steach.",
    "Success! Your account is fully activated, you now have access to all content.": "Dèanta! Chaidh an cunntas agad a chur an gnìomh agus tha cothrom-inntrigidh agad air a h-uile rud a-nis.",
    "Success! Your email is updated.": "Dèanta! Chaidh am post-d agad ùrachadh.",
    "Successfully unsubscribed": "Chan eil thu a’ fo-sgrìobhadh tuilleadh.",
    "Thank you for subscribing. Before you start reading, below are a few other sites you may enjoy.": "Tapadh leat airson fo-sgrìobhadh. Tha grunn làraich eil gu h-ìosal a dh’fhaodadh a bhith còrdadh riut.",
    "Thank you for your support": "Mòran taig airson do thaic a thoirt dhuinn",
    "Thank you for your support!": "Mòran taing airson do taic a thoirt dhuinn!",
    "Thanks for the feedback!": "Mòran taing airson leigeil fios dhuinn!",
    "That didn't go to plan": "Cha deach sin mar bu chòir",
    "The email address we have for you is {memberEmail} — if that's not correct, you can update it in your <button>account settings area</button>.": "’S e {memberEmail} am post-d a th’ againn dhut - faodaidh tu a cheartachadh anns na <button>roghainnean</button> agad.",
    "There was a problem submitting your feedback. Please try again a little later.": "Chaidh rudeigin ceàrr. Feuch a-rithist an ceann greis",
    "There was an error cancelling your subscription, please try again.": "Thachair mearachd agus dh'fhàillig dùbhadh às an fho-sgrìobhaidh, feuch a-rithist.",
    "There was an error continuing your subscription, please try again.": "Thachair mearachd agus dh'fhàillig ath-nuadhachadh an fho-sgrìobhaidh, feuch a-rithist.",
    "There was an error processing your payment. Please try again.": "Thachair mearachd fhad 's a bhathar a' làimhseachadh a' phàighidh agad. Feuch a-rithist.",
    "There was an error sending the email, please try again": "Thachair mearachd agus dh'fhàillig cur a' phuist-d, feuch a-rithist.",
    "This gift has already been consumed.": "",
    "This gift has already been redeemed.": "",
    "This gift has been refunded.": "",
    "This gift has expired.": "",
    "This site is invite-only, contact the owner for access.": "Feumar cuireadh airson an làrach-lìn seo, leig fios dhan rianaire ma tha thu ag iarraidh cothrom-inntrigidh.",
    "This site is not accepting donations at the moment.": "",
    "This site is not accepting payments at the moment.": "Chan eil an làrach seo a' gabhail ri phàighidhean an-dràsta.",
    "This site only accepts paid members.": "Chan fhaighear don làrach seo ach buill a tha air pàigheadh.",
    "Threads": "",
    "Tier": "",
    "To complete signup, click the confirmation link in your inbox. If it doesn't arrive within 3 minutes, check your spam folder!": "Dèan briog air a’ cheangal dearbhaidh a chaidh a chur dhan phost-d agad gus crìoch a chur an an clàradh agad. Thoir sùil air a’ phasgan spama mura faigh thu taobh a-staigh 3 mionaidean e.",
    "To continue to stay up to date, subscribe to {publication} below.": "Fo-sgrìobh gu h-ìosal gus cumail suas ris an fhoillseachadh, \"{publication}\".",
    "Too many attempts try again in {number} days.": "Tha tuilleadh 's còir oidhirpean ann an {number} là(ithean).",
    "Too many attempts try again in {number} hours.": "Tha tuilleadh 's còir oidhirpean ann an {number} uair(ean).",
    "Too many attempts try again in {number} minutes.": "Tha tuilleadh 's còir oidhirpean ann an {number} mionaid(ean).",
    "Too many different sign-in attempts, try again in {number} days": "Tha tuilleadh 's còir oidhirpean, feuch a-rithist an ceann {number} là(ithean)",
    "Too many different sign-in attempts, try again in {number} hours": "Tha tuilleadh 's còir oidhirpean, feuch a-rithist an ceann {number} uair(ean)",
    "Too many different sign-in attempts, try again in {number} minutes": "Tha tuilleadh 's còir oidhirpean, feuch a-rithist an ceann {number} mionaid(ean)",
    "Too many sign-up attempts, try again later": "",
    "Try free for {amount} days, then {originalPrice}.": "An-asgaidh airson {amount}l, agus {originalPrice} an dèidh sin ",
    "Unable to initiate checkout session": "Cha ghabh seisean pàighidh a thòiseachadh",
    "Unlock access to all newsletters by becoming a paid subscriber.": "Tig nad bhall phaighte gus cothrom fhaighinn air na cuairt-litrichean gu lèir.",
    "Unsubscribe from all emails": "Na fo-sgrìobh ri puist-d tuilleadh",
    "Unsubscribed": "Chan fhaigh thu puist-d tuilleadh",
    "Unsubscribed from all emails.": "Chan fhaigh thu puist-d tuilleadh.",
    "Unsubscribing from emails will not cancel your paid subscription to {title}": "Cuiridh seo stad air puist-d, cha cuir e stad air na tha thu a’ pàigheadh airson fo-sgrìobhadh gu {title}",
    "Update": "Ùraich",
    "Update your preferences": "Ùraich na roghainnean agad",
    "Updates & announcements": "",
    "Verification link sent, check your inbox": "Chaidh ceangal dearbhaidh a chur, thoir sùil air a’ phost-d agad",
    "Verify your email address is correct": "Dearbhaidh gu bheil a’ phost-d agad ceart",
    "Verifying...": "",
    "View plans": "Seall na planaichean",
    "We couldn't unsubscribe you as the email address was not found. Please contact the site owner.": "Cha deach am post-d a lorg. Leig fios dhan rianaire.",
    "We'd hate to see you leave. How about a special offer to stay?": "",
    "Welcome back, {name}!": "Fàilte air ais, {name}",
    "Welcome back!": "Fàilte air ais!",
    "Welcome to {siteTitle}": "Fàilte dhan làrach-lìn, {siteTitle}",
    "When an inbox fails to accept an email it is commonly called a bounce. In many cases, this can be temporary. However, in some cases, a bounced email can be returned as a permanent failure when an email address is invalid or non-existent.": "Dh’fhaodadh gur e mearachd sealach a tha seo, no dh’fhaodadh gur e post-d mì-dhligheach a th’ ann.",
    "Why has my email been disabled?": "Carson a chaidh am post-d agam a chur à comas?",
    "X (Twitter)": "",
    "year": "bliadhna",
    "Yearly": "Gach bliadhna",
    "You already have an active subscription.": "",
    "You currently have a free membership, upgrade to a paid subscription for full access.": "Tha ballrachd an-asgaidh agad an-dràsta, àrdaich gu ballrachd pàighte airson cothrom-inntrigidh air a h-uile rud.",
    "You have been successfully resubscribed": "Fo-sgrìobh thu a-rithist",
    "You now have access to {tierName} until {expiryDate}. Enjoy!": "",
    "You're currently not receiving emails": "Chan eil thu a’ faighinn puist-d an-dràsta",
    "You're not receiving emails": "Chan eil thu a’ faighinn puist-d",
    "You're not receiving emails because you either marked a recent message as spam, or because messages could not be delivered to your provided email address.": "Chan eil thu a’ faighinn puist-d air sgàth ’s gu bheil thu air brath a chomharradh mar spama o chionn ghoirid, no air sgàth ’s nach gabh brathan a chur dhan a’ phost-d a thug thu seachad.",
    "You've been gifted a membership": "",
    "You've been gifted a membership to {siteTitle}": "",
    "You've successfully signed in.": "Chlàraich thu a-steach gu soirbheachail.",
    "You've successfully subscribed to <strong>{siteTitle}</strong>": "Fo-sgrìobh thu gu soirbheachail gu <strong>{siteTitle}</strong>",
    "Your account": "An cunntas agad",
    "Your email": "",
    "Your email has failed to resubscribe, please try again": "Dh'fhàillig ath-nuadhachadh an fho-sgrìobhaidh, feuch a-rithist",
    "Your gift is ready": "",
    "Your gift subscription will expire on {expiryDate}": "",
    "your inbox": "",
    "Your input helps shape what gets published.": "Bheir na beachdan agad buaidh air na foillseachaidhean ri teachd.",
    "Your name": "",
    "Your subscription has been canceled and will expire on {expiryDate}.": "",
    "Your subscription will expire on {expiryDate}": "Falbhaidh an ùine air am fo-sgrìobhadh agad: {expiryDate}",
    "Your subscription will renew on {renewalDate}": "Ath-nuadhaichidh am fo-sgrìobhadh agad: {renewalDate}",
    "Your subscription will start on {subscriptionStart}": "Tòisichidh am fo-sgrìobhadh agad: {subscriptionStart}"
}
